import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.547 13.243 12 10.8m0 0 2.346 2.332M12 10.8v6m-9.6.741V5.258a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2v9.33a2.4 2.4 0 0 1-2.4 2.399H4.8a2.4 2.4 0 0 1-2.4-2.4"
    />
  </svg>
);
export default SvgFolderUp01;
